import React, {useState, useRef} from 'react';
import { useHistory,  useLocation} from 'react-router-dom';
import '../../../css/changepassword.scss';
import 'react-spring-bottom-sheet/dist/style.css'
import { useEffect } from "react";
import APICall from '../../actions/apicall';
import eyeicon from '../../../images/eyeicon.png';
import LoginBottomSheet from './LoginBottomSheet';
import Submit from '../reusable/Submit';

function ChangePassword() {
    const history = useHistory();

    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setconfirmNewPassword] = useState('');
    const [showContent, setShowContent] = useState(true);
    const [userId, setUserId] = useState('');
    const [linkId, setLinkId] = useState('');
    const [showMessage, setShowMessage] = useState(false);
    const [messageSentence, setMessageSentence] = useState('Password updated successfully.');
    const newPasswordElement = useRef();
    const confirmPasswordElement = useRef();
    const [isAccountBottomSheetOpen, setIsAccountBottomSheetOpen] = useState(false);
    const [showLoginButton, setShowLoginButton] = useState(false);
    const [submitText, setSubmitText] = useState('Submit');

    useEffect(() => {
        const url = window.location.href;
        const tokenMatch = url.match(/token=([^&]+)/);
        const tokenValue = tokenMatch ? tokenMatch[1] : '';

        APICall.VerifyResetPassword(tokenValue, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
                setUserId(response.data.data.user_id);
                setLinkId(response.data.data.link_id)
                setShowContent(true);
            }
            else {
                setShowContent(false);
            }
        });
    }, []);

    const handleAccountBottomSheetOpen = () => {
        setIsAccountBottomSheetOpen(true)
    }

    const handleAccountBottomSheetClose = (boolean) => {
        setIsAccountBottomSheetOpen(false)
    }

    const handleChangePassword = () => {
        if (newPassword != confirmPassword) {
            setMessageSentence("Your passwords don't match. Please try again.");
            setShowMessage(true);
            return
        }
        window.dataLayer.push({'event': 'reset_password'})
        setSubmitText('Submitting...');
        let data = {
            user_id: userId,
            link_id: linkId,
            password: newPassword
        }
        APICall.ChangePassword(data, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
                setSubmitText('Submit');
                setMessageSentence(response.data.message);
                setShowMessage(true);
                setShowLoginButton(true);
                history.push('/change-password');
            }
            else if (response.status == 400) {
                setSubmitText('Submit');
                setMessageSentence(response.data.message);
                setShowMessage(true);
            }
            else if (response.status == 404){
                setSubmitText('Submit');
                setShowContent(false);
            }
        });
    }

    const handleNewPassword = () => {
        if(newPasswordElement.current.type === 'password') {
            newPasswordElement.current.type = 'text';
        }
        else {
            newPasswordElement.current.type = 'password';
        }
    };

    const handleLogin = () => {
        setIsAccountBottomSheetOpen(true);
    }

    const handleConfirmPassword = () => {
        if(confirmPasswordElement.current.type === 'password') {
            confirmPasswordElement.current.type = 'text';
        }
        else {
            confirmPasswordElement.current.type = 'password';
        }
    }
    

    return(
        <div>
            {
                (isAccountBottomSheetOpen) && (
                <LoginBottomSheet 
                    isBottomSheetOpen={isAccountBottomSheetOpen}
                    onBottomSheetOpen={handleAccountBottomSheetOpen}
                    onBottomSheetClose={handleAccountBottomSheetClose}
                    showLoginContent={true}
                />)
            }
            {
                (showContent) ? (
                <div className='change-password-container'>        
                    <p className='change-text'>Reset Password</p>
                    <hr></hr>
                    <div className='reset-passwords'>
                        <div className='password-container'>
                            <input 
                                className="password-input" 
                                type="password"
                                placeholder='New Password' 
                                id='reset-password'
                                ref={newPasswordElement}
                                value={newPassword}
                                onChange={(e) => setNewPassword(e.target.value)}
                            />
                            <img src={eyeicon} className='eye-icon-class' onClick={() => handleNewPassword()} />
                        </div>
                        <div className='password-container'>
                            <input 
                                className="password-input" 
                                type="password"
                                placeholder='Confirm Password' 
                                id='reset-confirm-password'
                                ref={confirmPasswordElement}
                                value={confirmPassword}
                                onChange={(e) => setconfirmNewPassword(e.target.value)}
                                onKeyPress={(e) => ((e.key == 'Enter') && handleChangePassword())}
                            />
                            <img src={eyeicon} className='eye-icon-class' onClick={() => handleConfirmPassword()} />
                        </div>
                        {
                            (showMessage) && (
                                <p className='success-message'>{messageSentence}</p>
                            )
                        }
                    </div>
                    {
                        (showLoginButton) ? (
                            <button className='submit-button' onClick={handleLogin}>
                                <span>Back To Login</span>
                            </button>
                        ) : (
                        (newPassword.trim().length != 0 && confirmPassword.trim().length != 0) ? (
                            <Submit actionText={submitText} callFunction={handleChangePassword} disable={submitText != 'Submit' && true} />
                        ) : (
                            <Submit actionText={'Submit'} disable={'button'} />
                        ))
                    }
                </div>) : (
                <div className='expire-container'>
                    <p className='expire-message'>You have already reset your password or the Reset Password link has expired. Please try again.</p>
                </div>
                )
            }
        </div>
    )
}

export default ChangePassword;

